import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Platform, StyleSheet, Text } from 'react-native';

import Theme from '../../theme';
import { BaseModal } from '../../ui';
import { UserDataConsumer } from '../../utils';
import { Button, ButtonTypes } from '../../components';
import { toggleUserProfileModalVisible } from '../../ui/redux/uiActions';
import { mappedIcons, mappedTitles } from '../../WorkoutGoalAssistant/utils';
import { moderateScale } from 'react-native-size-matters';

const isSmallMobile = window.innerWidth <= 350;
class UserProfileModal extends Component<any, any> {
  constructor(props) {
    super(props);

    const {
      user: {
        userProfile: {
          privateProfile = false,
        },
      }
    } = this.props;

    this.state = {
      privateProfile,
      isLoading: false,
    };
  }

  closeSettings = () => {
    this.props.setSuccessOrFailMessage(undefined);
    this.props.toggleUserProfileModalVisible(false);
  }

  blockOrUnblock = (partner: any) => {
    const { t } = this.props;
    if (this.props.listType === t('blacklist')) {
      this.props.unblock(partner);
    } else {
      this.props.block(partner);
    }
  }

  render() {
    const {
      privateProfile: statePrivateProfile,
    } = this.state;
    const { t, isFetching } = this.props;
    const {
      isModalVisible,
      user: {
        userProfile
      },
    } = this.props;
    return (
      <View style={styles.container}>
        <BaseModal
          closeModal={this.closeSettings}
          isModalVisible={isModalVisible}
          headerTextStyle={styles.noHeaderBorder}>
          <View style={styles.modalContainer}>
            <Text style={styles.goal}>{this.props.partner && this.props.partner.fullname}</Text>
            {this.props.listType !== 'blacklist' &&
              <View>
                <Button
                  fontColor={Theme.WHITE}
                  isLoading={isFetching}
                  title={this.props.listType === t('whitelist') ? t('remove') : this.props.listType === t('searchlist') && t('add')}
                  containerStyle={{ borderRadius: 5, marginTop: 10 }}
                  onPress={() => this.props.onPress(this.props.partner)}
                />
              </View>
            }
            {this.props.partner &&
              <View>
                <View style={styles.detailContainer}>
                  <Text style={styles.detailLabel}>Nickname:</Text>
                  <Text style={styles.detailValue}>{this.props.partner.nickname}</Text>
                </View>
              </View>
            }
            {this.props.listType &&
              <View style={styles.footer}>
                <Button
                  fontColor={Theme.PRIMARY}
                  isLoading={isFetching}
                  title={this.props.listType === t('blacklist') ? t('unblock') : t('block')}
                  containerStyle={{ borderRadius: 5, marginTop: 10 }}
                  buttonType={ButtonTypes.OUTLINE}
                  onPress={() => this.blockOrUnblock(this.props.partner)}
                />
                {this.props.message &&
                  <Text style={styles.returnMessage}>{this.props.message}</Text>
                }
              </View>
            }
          </View>
        </BaseModal>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Platform.OS === 'web' ? Theme.CHARCOAL : Theme.WHITE,
  },
  headerContainer: {
    flexDirection: 'row',
    zIndex: 1,
    width: '100%',
    marginTop: -45,
  },
  modalContainer: {
    flex: 1,
    paddingHorizontal: 15,
  },
  footer: {
    flex: 1,
    alignContent: 'flex-end',
    justifyContent: 'flex-end',
  },
  goalHeader: {
    flexDirection: 'column',
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 10,
    zIndex: 1,
    alignItems: 'flex-start'
  },
  goal: {
    alignSelf: 'flex-start',
    marginTop: 3,
    fontSize: moderateScale(15, 1),
    color: Theme.BLACK,
    fontFamily: Theme.Custom700,
  },
  titleContainer: {
    flexDirection: 'row',
  },
  title: {
    fontWeight: '200',
    color: Theme.BLACK,
    alignSelf: 'flex-start',
    fontSize: isSmallMobile ? 11 : 14,
  },
  iconContainer: {
    marginTop: 15,
    marginLeft: 15,
    width: moderateScale(27, 2),
    height: moderateScale(24, 2),
  },
  noHeaderBorder: {
    borderBottomWidth: 0,
  },
  detailLabel: {
    fontFamily: Theme.Custom700,
    alignSelf: 'flex-start'
  },
  detailValue: {
    fontFamily: Theme.Custom400,
  },
  detailContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  returnMessage: {
    marginTop: 30,
    marginBottom: 10,
    fontFamily: Theme.Custom700,
    color: Theme.BLACK
  }
});

const mapDispatchToProps = (dispatch) => {
  return {
    toggleUserProfileModalVisible: (visible) => dispatch(toggleUserProfileModalVisible(visible)),
  }
}

const UserProfileModalComponent = connect(state => {
  return {
    isModalVisible: state.ui.userProfileModalVisible,
  };
}, mapDispatchToProps)(UserProfileModal)
const UserProfileModalTranslate = translate(['workoutPartners'], { wait: true })(UserProfileModalComponent);
export default UserDataConsumer(UserProfileModalTranslate);
